import React from 'react';
import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexCol } from '../misc';
import { Box } from 'grid-styled/emotion';

const Header = styled('header')`
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 2px solid ${themeGet('colors.greyLight')};
  flex: 0 0 65px;
  max-height: 65px;
  padding: 0 ${themeGet('space.4')}px;
`;

// ---
// Shop.
// ---
const ShopWrapper = styled(FlexCol)`
  width: 100%;
  height: 100%;
`;

const ShopBodyWrapper = styled(FlexCol)`
  flex: 1;
  overflow: hidden;

  @media screen and (min-width: 52em) {
    flex-direction: row;
  }
`;

const ShopHeader = styled(Header)`
  justify-content: space-between;
  background-color: ${themeGet('colors.greyLighter')};
`;

const LeftShopBody = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 80px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  z-index: 2;

  @media screen and (min-width: 52em) {
    flex: 0 0 33vw;
    max-width: 380px;
  }

  @media screen and (min-width: 64em) {
    flex: 0 0 30vw;
  }

  @media screen and (min-width: 76em) {
    flex: 0 0 25vw;
  }
`;

const RightShopBody = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media screen and (min-width: 52em) {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 0;
    width: 100%;
    padding: 0 ${themeGet('space.4')}px;
  }
`;

const ShopLayout = ({ children }) => <ShopWrapper>{children}</ShopWrapper>;

ShopLayout.Header = ShopHeader;
ShopLayout.BodyWrapper = ShopBodyWrapper;
ShopLayout.LeftBody = LeftShopBody;
ShopLayout.RightBody = RightShopBody;

// ---
// Checkout.
// ---
const CheckoutWrapper = styled('main')`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const LeftCheckout = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 52em) {
    flex: 0 0 calc(100% - 400px);
    display: flex;
    flex-direction: column;
  }

  @media screen and (min-width: 76em) {
    flex: 0 0 calc(100% - 460px);
  }
`;

const LeftCheckoutHeader = styled(Header)`
  justify-content: space-between;
`;

const LeftCheckoutBody = styled('div')`
  background: ${themeGet('colors.greyLightest')};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${themeGet('space.4')}px;

  @media screen and (min-width: 64em) {
    height: calc(100% - 65px);
  }
`;

const RightCheckout = styled('div')`
  position: fixed;
  pointer-events: none;
  z-index: 0;

  @media screen and (min-width: 52em) {
    transform: none;
    opacity: 1;
    pointer-events: auto;
    position: relative;
    flex: 0 0 400px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 30px 2px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }

  @media screen and (min-width: 76em) {
    flex: 0 0 460px;
  }
`;

const RightCheckoutHeader = styled(Header)`
  padding: 0 ${themeGet('space.4')}px;
  display: none;

  @media screen and (min-width: 52em) {
    display: flex;
  }
`;

const CheckoutLayout = ({ children }) => (
  <CheckoutWrapper>{children}</CheckoutWrapper>
);

CheckoutLayout.Left = LeftCheckout;
CheckoutLayout.LeftHeader = LeftCheckoutHeader;
CheckoutLayout.LeftBody = LeftCheckoutBody;
CheckoutLayout.Right = RightCheckout;
CheckoutLayout.RightHeader = RightCheckoutHeader;

const OrderWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const OrderHeader = styled(Header)`
  justify-content: center;
`;

const OrderBody = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  background: #f8fbfd;
  position: relative;
`;

const OrderLayout = ({ children }) => <OrderWrapper>{children}</OrderWrapper>;

OrderLayout.Header = OrderHeader;
OrderLayout.Body = OrderBody;

export default { ShopLayout, CheckoutLayout, OrderLayout };



// WEBPACK FOOTER //
// ../shop_main/components/layout/style.js